import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class LoginService {
  static login(params) {
    return HttpUtil.uniterceptedPost(API_ROUTES.LOGIN.LOGINAPI, params);
  }

  static checkAuthority(params) {
    return HttpUtil.get(API_ROUTES.LOGIN.AUTHORITYAPI);
  }

  static profileComplete(companyId) {
    return HttpUtil.get(API_ROUTES.LOGIN.PROFILECOMPLETE+`${companyId}/status`);
  }
 
}
